module.exports = __webpack_public_path__ + "static/media/7.question.5e862bcd.mp4";